export const DAYU_LOGO = 'https://dayu-1258344701.cos.ap-guangzhou.myqcloud.com/dayu_logo/dayu_rta.png';

export const LOGIN_CODE = {
  ERROR: -1,
  SYSTEM_ERROR: -2,
};
